export const WITHOUT_LABEL = { 'ui:label': false }
export const RADIO_WIDGET = { 'ui:widget': 'radio' }
export const RANGE_WIDGET = { 'ui:widget': 'range' }
export const HIDDEN_WIDGET = { 'ui:widget': 'hidden' }
export const READONLY_WIDGET = { 'ui:readonly': true }
export const TEXTAREA_WIDGET = { 'ui:widget': 'textarea' }
